import { render, staticRenderFns } from "./cpt-chart-td-column.vue?vue&type=template&id=ea60e7f8&scoped=true&"
import script from "./cpt-chart-td-column.vue?vue&type=script&lang=js&"
export * from "./cpt-chart-td-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea60e7f8",
  null
  
)

export default component.exports